import { render, staticRenderFns } from "./SetQuestions.vue?vue&type=template&id=78bd2706&"
import script from "./SetQuestions.vue?vue&type=script&lang=js&"
export * from "./SetQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports